import BranchArrivalRatesPerService from "../../../components/branches/reports/daily/BranchArrivalRatesPerService";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyBranchArrivalRatesPerService = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    branchScoped={true}
    reportTypeId={REPORT_TYPE_IDS.daily_branch_arrival_rates_per_service}
    title="Arrival Rates Per Service"
    helmetTitle="Daily Branch Arrival Rates Per Service"
    descriptionKey="BranchesArrivalRatesPerService"
    columnDefinitions={ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS}
    defaultSortColumn="total"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) => (
      <BranchArrivalRatesPerService
        data={data}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    )}
  </DailyGeneratedReportPage>
);

export default DailyBranchArrivalRatesPerService;
